<footer class="usa-footer">
	<div class="usa-footer__primary-section ">
		<div class="usa-footer__primary-section ">
			<nav class="usa-footer__nav padding-bottom-2 padding-top-1">
				<div class="grid-row grid-gap display-flex flex-column flex-align-center">
					<div class="usa-footer__primary-content font-sans-3xs padding-top-1">
						EFAST2, an all-electronic system, receives and displays Forms 5500 Series Annual Returns/Reports and Form PR Pooled Plan Provider Registrations on behalf of  <a href="https://www.dol.gov/agencies/ebsa" target="_blank">DOL</a>, <a href="https://www.irs.gov/retirement-plans/form-5500-corner" target="_blank">IRS</a>, and <a href="https://www.pbgc.gov" target="_blank">PBGC</a>
					</div>
					<div class="grid-row grid-gap flex-align-center padding-top-1">
						<div class="usa-footer__primary-content font-sans-3xs">
							<a href="../../about/about_efast2.html">About EFAST2</a>
						</div>
						<div class="usa-footer__primary-content font-sans-3xs">
							<a href="https://www.dol.gov/agencies/ebsa/about-ebsa/our-activities/resource-center/related-resources" target="_blank">Related Resources</a>
						</div>
						<div class="usa-footer__primary-content font-sans-3xs">
							<a href="https://www.dol.gov/general/privacynotice"target="_blank">Privacy &amp; Security Statement</a>
						</div>
						<div class="usa-footer__primary-content font-sans-3xs">
							<a href="https://www.oig.dol.gov/" target="_blank">Office of the Inspector General</a>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</div>
</footer>